<template>
   <span >
         <v-avatar @click="showImage">
                    <v-img :src="src"></v-img>
                </v-avatar>
         <v-dialog v-model="dialog" width="500">
            <v-img :src="src"></v-img>
         </v-dialog>
   </span>
</template>

<script>
    export default {
        name: "AvatarImageModal",
        props: ['src'],
        data() {
            return {
                dialog: false
            }
        },
        methods: {
            showImage() {
                this.dialog = true;
            }
        },
    }
</script>

<style scoped>

</style>
